// extracted by mini-css-extract-plugin
export default {"TopAppBar":"topAppBar_TopAppBar__0NLYk","title":"topAppBar_title__i-aPr"};